import { config } from "../../../config";
import { IRestaurant } from "../../../types/items";
import { useHttp } from "../../../hooks";
import useSWR from "swr";
import { useEffect } from "react";

type TProp = {
  token: string;
  setRestaurant: React.Dispatch<React.SetStateAction<string>>;
  restaurant: string;
  agreementUk: string;
  agreementEn: string;
  setUserPolicyUk: React.Dispatch<React.SetStateAction<string>>;
  setUserPolicyEn: React.Dispatch<React.SetStateAction<string>>;
};

export const useAgreementLogic = ({
  token,
  setRestaurant,
  restaurant,
  agreementUk,
  agreementEn,
  setUserPolicyUk,
  setUserPolicyEn,
}: TProp) => {
  const { request } = useHttp();

  const getRestaurants = async (): Promise<IRestaurant[]> =>
    await request(
      `${config.API}/restaurants/?page=1&perPage=12`,
      "GET",
      null,
      {
        Authorization: `Bearer ${token as string}`,
      },
      true
    );

  const { data: restaurants } = useSWR("getRestaurants", getRestaurants, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });

  useEffect(() => {
    if (restaurants) {
      setRestaurant(restaurants[0]?._id);
    }
  }, [restaurants, setRestaurant]);

  const getVariables = async (): Promise<{
    privacyPolicy: { value: string; lang: string }[];
  }> =>
    await request(
      `${config.API}/variables`,
      "GET",
      null,
      {
        Authorization: `Bearer ${token as string}`,
      },
      true
    );
  const { data: privasyData } = useSWR("getPrivasyPolisy", getVariables, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });

  useEffect(() => {
    if (privasyData) {
      const uk =
        privasyData.privacyPolicy?.find((el) => el.lang === "uk")?.value || "";
      const en =
        privasyData.privacyPolicy?.find((el) => el.lang === "en")?.value || "";
      setUserPolicyEn(en);
      setUserPolicyUk(uk);
    }
  }, [privasyData, setUserPolicyEn, setUserPolicyUk]);

  const updateRestaron = async () => {
    const data: FormData = new FormData();
    data.append(
      "userAgreement",
      JSON.stringify([
        { lang: "en", value: agreementEn },
        { lang: "uk", value: agreementUk },
      ])
    );

    await request(`${config.API}/restaurants/${restaurant}`, "POST", data, {
      Authorization: `Bearer ${token as string}`,
    });
  };
  return { restaurants, updateRestaron };
};
